import * as React from 'react';
import {Grid, Typography, useMediaQuery} from '@mui/material';
import {consistentSpacing} from '../APIForms/variables';

/**
 * Component representing the initial screen for Dermadetect.
 *
 * @component
 * @returns {JSX.Element} The DermadetectInitial component.
 */
export const DermadetectInitial = () => {
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const initialText = isSmallScreen ? 'start' : 'start my screening';
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      sx={{
        textAlign: 'center',
        mx: 'auto',
      }}
      rowGap={consistentSpacing}
    >
      <Grid item>
        <Typography variant="h4" sx={{my: {xs: 1, sm: 2}}}>
          Let's check your body for skin conditions.
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          sx={{
            width: '100%',
            maxWidth: '650px',
            fontWeight: 500,
          }}
        >
          Based on your preliminary results, we think you might benefit from screening for{' '}
          <strong>dermatological conditions.</strong>
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          sx={{
            marginTop: 4,
            width: '100%',
            maxWidth: '650px',
            fontWeight: 500,
          }}
        >
          To further understand your symptoms, we suggest our dermatology screening tool that can check for multiple
          skin conditions with <strong>92% accuracy.</strong>
        </Typography>
      </Grid>
      <Grid item>
        <Typography sx={{marginTop: 3, fontWeight: 500}}>
          Press <strong>{initialText}</strong> to continue.
        </Typography>
      </Grid>
    </Grid>
  );
};
